export const interpolate = (template: string, data: Record<string, unknown>) => {
  for (const [key, value] of Object.entries(data)) {
    template = template.replace(new RegExp(`\\[\\[__${key}__\\]\\]`, 'g'), String(value));
  }

  return template;
};
